import { ASSETS_HOST } from '../config';

const EXTENSION_REGEX = /\.\w+$/;

export const buildBannerUrl = (path: string, density = 1): string => {
    const url = ASSETS_HOST + path;

    return density === 1 ? url : url.replace(EXTENSION_REGEX, (extension) => `@${density}x${extension}`);
};

export const buildBannerSrcSet = (path: string, maxDensity: number): string =>
    Array.from({ length: maxDensity }, (_, index) => index + 1)
        .map((density) => `${buildBannerUrl(path, density)} ${density}x`)
        .join(', ');
